import { useQuery } from '@tanstack/react-query'
import { getEventImportCandidates } from 'app/frontend/base/api/event'

export const useEventImportCandidates = (
  teamId: number,
  eventId: number,
  enabled: boolean,
) => {
  const { data, isFetching } = useQuery({
    queryKey: ['eventImportCandidates', { teamId, eventId }],
    enabled,
    queryFn: async () => getEventImportCandidates(teamId, eventId),
  })

  return {
    importCandidates: data?.importCandidates ?? [],
    isFetching,
  }
}
